module.exports = __webpack_public_path__ + "static/media/logo.152e02fe.svg";